const Message = ({ messageId, subject, read, active, onMessageClick }) => {
  return (
    <div
      className={`message ${read ? "message--read" : ""} ${
        active ? "message--active" : ""
      }`}
      onClick={() => onMessageClick(messageId)}
    >
      {!read && <div className="message_unread-badge" />}
      <div className="message_content">{subject}</div>
    </div>
  );
};

export default Message;
